<template>
  <div class="section-main__warp devicemg_warps">
    <ioc-table ref="crud"
              v-model="form"
              :data="tableData"
              :option="option"
              :page="page"
              @search-change="handleSearchChange"
              @search-reset="handleSearchReset"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              @refresh-change="refreshChange"
              @selection-change="handleSelectionChange"
    >
      <template slot="menuLeft">
        <el-button v-auth="'/deviceMg/carameGroup:add'"
                   type="primary"
                   class="iss-operation-button"
                   icon="iconfont icon-xinzeng"
                   @click="handleAdd"
        >
          {{ $t('deviceMg.button.add') }}
        </el-button>
        <el-button v-auth="'/deviceMg/carameGroup:delete'"
                   class="iss-operation-button"
                   type="info"
                   icon="el-icon-delete"
                   @click="handelBatchDel"
        >
          {{ $t('deviceMg.button.batchDelete') }}
        </el-button>
      </template>
      <template slot="menu"
                slot-scope="scope"
      >
        <el-tooltip class="item"
                    effect="dark"
                    :content="$t('deviceMg.button.edit')"
                    placement="top"
                    popper-class="tooltip-draw"
        >
          <el-button v-auth="'/deviceMg/carameGroup:update'"
                     type="text"
                     icon="iconfont icon-xiugai"
                     @click="handleEdit(scope.row,scope.index)"
          ></el-button>
        </el-tooltip>
        <el-tooltip class="item"
                    effect="dark"
                    :content="$t('deviceMg.button.delete')"
                    placement="top"
                    popper-class="tooltip-draw"
        >
          <el-button v-auth="'/deviceMg/carameGroup:delete'"
                     type="text"
                     icon="iconfont icon-shanchu"
                     @click="handleDel(scope.row,scope.index)"
          ></el-button>
        </el-tooltip>
      </template>
    </ioc-table>
    <el-dialog :title="$t('deviceMg.title.add')" :visible.sync="controlWindowShow" v-dialogDrag :modal="false" width="680px" @opened="addDialogOPen">
      <el-form ref="ruleForm" :label-position="labelPosition" label-width="120px" :model="formNew" :rules="rules" :status-icon="true">
        <el-form-item :label="$t('deviceMg.label.cameraName')" prop="bayonetName">
          <el-input v-model="formNew.bayonetName" style="width: 80%" :placeholder="$t('deviceMg.placeholder.cameraName')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('deviceMg.label.type')" prop="type">
          <el-radio-group v-model="formNew.type" @change="cameraList=[];cameraNameList=[]">
            <el-radio :label="1">{{ $t('deviceMg.label.car') }}</el-radio>
            <el-radio :label="2">{{ $t('deviceMg.label.people') }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="$t('deviceMg.label.area')" prop="areaDevGroupName" class="sbar">
          <el-input v-model="formNew.areaDevGroupName" style="width: 80%;" :placeholder="$t('deviceMg.placeholder.area')"
                    class="forbid-input" :disabled="true"
          ></el-input>
          <div class="open-cameta-button" @click="toggleCameraShow">
            <span>{{ $t('deviceMg.title.select') }}</span>
          </div>
          <div class="camera-list-title">{{ $t('deviceMg.title.cameraList') }}</div>
          <el-scrollbar class="camera-list">
            <div v-for="(item ,index) in cameraNameList" :key="index">
              {{ item }}
              <span class="el-icon-delete add-account-delete camera-delete-icon"
                    @click="cameraNameList.splice(index, 1);cameraList.splice(index, 1)"
              >&nbsp;&nbsp;&nbsp;</span>
            </div>
          </el-scrollbar>
        </el-form-item>
        <!-- <el-form-item class="tc" label-width="0">
          <el-button type="primary" :loading="addLoading" @click="submitForm('ruleForm')">
            {{ $t('deviceMg.button.save') }}
          </el-button>
          <el-button @click="controlWindowShow = false">
            {{ $t('deviceMg.button.Cancel') }}
          </el-button>
        </el-form-item> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" :loading="addLoading" @click="submitForm('ruleForm')">
          {{ $t('deviceMg.button.save') }}
        </el-button>
        <el-button @click="controlWindowShow = false">
          {{ $t('deviceMg.button.Cancel') }}
        </el-button>
      </span>
    </el-dialog>
    <el-dialog :title="$t('deviceMg.title.edit')" :visible.sync="editWindowShow" :modal="false" width="680px" v-dialogDrag>
      <el-form ref="ruleForm2" :label-position="labelPosition" label-width="120px" :model="formNew" :rules="rules"
               :status-icon="true"
      >
        <el-form-item :label="$t('deviceMg.label.cameraName')" prop="bayonetName">
          <el-input v-model="formNew.bayonetName" style="width: 80%" :placeholder="$t('deviceMg.placeholder.cameraName')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('deviceMg.label.type')" prop="type">
          <el-radio-group v-model="formNew.type" disabled>
            <el-radio :label="1">{{ $t('deviceMg.label.car') }}</el-radio>
            <el-radio :label="2">{{ $t('deviceMg.label.people') }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="$t('deviceMg.label.area')" prop="areaDevGroupName" class="sbar">
          <el-input v-model="formNew.areaDevGroupName" style="width: 80%;" :placeholder="$t('deviceMg.placeholder.area')"
                    class="forbid-input" :disabled="true"
          ></el-input>
          <div class="open-cameta-button" @click="toggleCameraShow">
            <span>{{ $t('deviceMg.title.select') }}</span>
          </div>
          <div class="camera-list-title">
            {{ $t('deviceMg.title.cameraList') }}
          </div>
          <el-scrollbar class="camera-list">
            <div v-for="(item ,index) in cameraNameList" :key="index">
              {{ item }}
              <span class="el-icon-delete add-account-delete camera-delete-icon"
                    @click="cameraNameList.splice(index, 1);cameraList.splice(index, 1)"
              >&nbsp;&nbsp;&nbsp;</span>
            </div>
          </el-scrollbar>
        </el-form-item>
        <el-form-item class="tc" label-width="0">
          <el-button :loading="editLoading" type="primary" @click="submitEidtForm('ruleForm2')">
            {{ $t('deviceMg.button.save') }}
          </el-button>
          <el-button @click="editWindowShow = false">{{ $t('deviceMg.button.Cancel') }}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog v-ops:width="700" v-dialogDrag :title="$t('deviceMg.title.choseCamera')" :visible.sync="cameraWindowShow" :modal="false" @opened="cameraOpen">
      <bu-camera ref="buCamera" style="background:transparent;border:none" :cameraFeature="formNew.type === 1 ? 2 : 1" :ischild="1" @careraData="getCameraList"></bu-camera>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="getCameraData">
          {{ $t('deviceMg.button.confirm') }}
        </el-button>
        <el-button @click="closeCameraWindow">
          {{ $t('deviceMg.button.Cancel') }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {api} from '../api'
import {tableOption} from '../options/table'
import buCamera from '../components/app-area-cameraList/index'
import utils from '@src/common/utils'
import {Base, Dates} from '$utils'

export default {
  components: {
    buCamera
  },
  data() {
    return {
      addLoading: false,
      editLoading: false,
      searchParams: {},
      cameraList: [],
      cameraNameList: [],
      cameraWindowShow: false,
      editWindowShow: false,
      dataList: [],
      defaultProps: {
        children: 'childrens',
        label: 'areaDevGroupName',
        id: 'areaDevGroupCode'
      },
      rules: {
        bayonetName: [
          {required: true, message: this.$t('deviceMg.message.cameraName'), trigger: 'blur'},
          { min: 1, max: 30, message: this.$t('deviceMg.message.values'), trigger: 'blur' },
          {
            pattern: /^[\u4e00-\u9fa5a-zA-Z-z0-9]{0,30}$/,
            message: this.$t('deviceMg.message.value'),
            trigger: 'blur'
          }
        ],
        type: [
          {required: true, message: this.$t('deviceMg.message.type'), trigger: 'change'}
        ],
        areaDevGroupName: [
          {required: true, message: this.$t('deviceMg.message.area'), trigger: 'blur'}
        ]
      },
      labelPosition: 'right',
      controlWindowShow: false,
      loading: true,
      form: {},
      formNew: {},
      tableData: [],
      checkedDivs: [],
      page: {
        currentPage: 1,
        total: 0,
        pageSize: utils.Cache.get('CURRENT_PAGESIZE') || 10
      },
      option: tableOption()
    }
  },
  created() {
    this.refreshChange(this.page)
    console.log(this.option)
  },
  methods: {
    // 重置表单
    resetForm(name) {
      this.formNew = {}
      this.cameraNameList = []
      this.cameraList = []
      this.$refs[name].resetFields();
    },
    //照相机列表弹窗点确定
    getCameraData() {
      // if (this.$refs.buCamera.cameraList.length === 0) {
      //     this.$message.warning('请选择摄像机列表')
      //     return
      // }
      this.cameraWindowShow = false
    },
    //照相机列表弹窗点取消
    closeCameraWindow() {
      this.cameraWindowShow = false
      this.cameraList = []
      this.cameraNameList = []
      // this.formNew.parentCodes = ''
      // this.formNew.areaDevGroupCode = ''
    },
    // 摄像机列表打开的回调
    cameraOpen() {
      this.$refs.buCamera.cameraList = []
      this.$refs.buCamera.cameraNameList = []
      this.$refs.buCamera.tableData = []
      this.$refs.buCamera.checkList = []
      this.$refs.buCamera.devText = ''
      this.$refs.buCamera.queryDevice()
    },
    // 新增窗口打开的回调，每次打开窗口重置表单
    addDialogOPen() {
      this.resetForm('ruleForm')
      this.formNew.type = 1
    },
    //获取相机列表和父节点id
    getCameraList(val) {
      console.log('val', val)
      // this.cameraList = val[0]
      // this.cameraNameList = val[1]
      this.cameraList = [];
      this.cameraNameList = [];
      val.map(item => {
        this.cameraList.push(item.thirdDeviceId)
        this.cameraNameList.push(item.deviceName)
      })
      this.formNew.areaDevGroupName = val[0].areaName
      this.formNew.areaDevGroupCode = val[0].area
    },
    // getAreaDevGroupCode(val) {
    //     // this.formNew.parentCodes = val[0]
    //     this.formNew.areaDevGroupName = val[1];
    //     this.formNew.areaDevGroupCode = val[2];
    // },
    toggleCameraShow() {
      this.cameraWindowShow = true
    },
    //新增表单提交
    submitForm(formName) {
      if (!this.formNew.areaDevGroupCode) {
        this.$message.warning(this.$t('deviceMg.message.area'))
        return
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.handleCreate()
        } else {
          // 修复摄像机列表表单验证bug
          this.$refs[formName].clearValidate('areaDevGroupCode')
          return false;
        }
      });
    },
    // 修改表单提交
    submitEidtForm(formName) {
      if (!this.formNew.areaDevGroupCode) {
        this.$message.warning(this.$t('deviceMg.message.area'))
        return
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.handleUpdate()
        } else {
          // 修复摄像机列表表单验证bug
          this.$refs[formName].clearValidate('areaDevGroupCode')
          return false;
        }
      });
    },
    // 获取表格数据
    getList(page) {
    //   const _this = this
      let mbayonetQryReqVo = {
        bayonetName: this.searchParams.bayonetName,
        createTime: Dates.format(this.searchParams.createTime ? this.searchParams.createTime[0] : '', 'yyyy-MM-dd HH:mm:ss'),
        endTime: Dates.format(this.searchParams.createTime ? this.searchParams.createTime[1] : '', 'yyyy-MM-dd HH:mm:ss'),
        type: this.searchParams.type
      }
      let searchParams = {
        pageNum: page.currentPage,
        pageSize: page.pageSize,
        mbayonetQryReqVo: mbayonetQryReqVo
      }
      this.$fetch(
        api.SERVICE.querybayonet,
        searchParams
      ).then(response => {
        // 使用lodash处理返回数据使其在控制台不报错
        this.tableData = this._.get(response, 'returnObj.list')
        this.page.total = this._.get(response, 'returnObj.total')
      })
    },
    refreshChange() {
      this.getList(this.page)
    },
    handleCurrentChange(val) {
      // 页码改变时清空表格多选的选中状态
      this.$refs.crud.selectClear();
      this.page.currentPage = val
      this.refreshChange(this.page)
    },
    handleSizeChange(val) {
      this.page.currentPage = 1;
      this.page.pageSize = val;
      this.refreshChange(this.page)
    },
    handleSearchChange(param) {
      // 修改日期查询bug2691
      if(param.createTime && param.createTime.length === 1) {
        param.createTime = [Date(), Date()]
      }
      this.searchParams = Base.deepClone(param)
      this.page.currentPage = 1
      this.getList(this.page)
    },
    handleSearchReset() {
      this.page.currentPage = 1
      this.searchParams = {};
      this.$refs.crud.selectClear();
      this.refreshChange(this.page)
    },
    handleAdd() {
      this.controlWindowShow = true
    },
    handleEdit(row, index) {
      console.log('index', index)
      this.formNew = Base.deepClone(row)
      this.cameraNameList = []
      this.cameraList = []
      this.queryBayonetInfo(row.code)
      // this.cameraList = this._.map(this.formNew.cameraBayInfos, 'cameraCode');
      // this.cameraNameList = this._.map(this.formNew.cameraBayInfos, 'deviceName');
      // this.editWindowShow = true
    },
    //查询卡口详情
    queryBayonetInfo(code) {
      let self = this
      this.$fetch(
        api.SERVICE.querybayonetinfo,
        {code: code}
      ).then(response => {
        if (!response.success) {
          this.$message.error(response.msgContent)
          this.$message({
            type: 'info',
            message: this.$t('deviceMg.message.details')
          })
          return
        }
        const cameraListDetail = response.returnObj[0]
        self.formNew.cameraBayInfos = cameraListDetail.cameraBayInfos
        self.cameraList = _.map(cameraListDetail.cameraBayInfos, 'cameraCode')
        self.cameraNameList = _.map(cameraListDetail.cameraBayInfos, 'deviceName')
        self.formNew.areaDevGroupCode = cameraListDetail.areaDevGroupCode
        self.editWindowShow = true
      }).catch(() => {
        this.$message({
          type: 'info',
          message: this.$t('deviceMg.message.abnormal')
        })
      })
    },
    handleDel(row, index) {
      console.log('index', index)
      const params = {
        bayonetList: [row.code]
      }
      this.$confirm(
        this.$t('deviceMg.message.deleteWarn'),
        this.$t('deviceMg.title.remind'),
        {
          confirmButtonText: this.$t('deviceMg.button.confirm'),
          cancelButtonText: this.$t('deviceMg.button.Cancel'),
          type: 'warning'
        }
      )
        .then(() => {
          this.$fetch(api.SERVICE.deletebayonet, params).then((response) => {
            if (!response.success) {
              this.$message.error(response.msgContent)
              return
            }
            this.$message.success(this.$t('deviceMg.message.deleteSuccess'))
            this.getList(this.page)
          })
        })
    },
    handelBatchDel() {
      if (this.checkedDivs.length === 0) {
        this.$message.warning(this.$t('deviceMg.message.noDelete'))
        return
      }
      const params = {
        bayonetList: this.checkedDivs
      }
      this.$confirm( this.$t('deviceMg.message.batchDeleteWarn'), this.$t('deviceMg.title.remind'), {
        cancelButtonText: this.$t('deviceMg.button.Cancel'),
        confirmButtonText: this.$t('deviceMg.button.confirm'),
        type: 'warning'
      })
        .then(() => {
          this.$fetch(api.SERVICE.deletebayonet, params)
            .then(response => {
              if (!response.success) {
                this.$message.error(response.msgContent.split(':')[1])
                return
              }
              this.$refs.crud.selectClear();
              this.$message.success(this.$t('deviceMg.message.deleteSuccess'))
              this.getList(this.page)
            })
            .cache(() => {
              this.$message.error(this.$t('deviceMg.message.deleteFail'))
            })
        })
    },
    /*
        *@name:摄像机组新增
        *@param:{type}
        *@description:
        *@return:
        *@author: zhengff
        *@date: 2019-05-06 14:08:29
    */
    handleCreate() {
      this.addLoading = true
      const params = {
        areaDevGroupCode: this.formNew.areaDevGroupCode,
        bayonetName: this.formNew.bayonetName,
        cameraList: this.cameraList,
        // parentCodes: this.formNew.parentCodes,
        type: Number(this.formNew.type)
      }
      this.$fetch(api.SERVICE.addBayonet, params)
        .then(res => {
          if (res && res.success) {
            this.getList(this.page)
            this.controlWindowShow = false
            this.$message.success(this.$t('deviceMg.message.create'))
            this.controlWindowShow = false
            this.addLoading = false
          } else {
            this.$message.error(res.msgContent)
            this.addLoading = false
          }
        })
        .catch(() => {
          this.$message.error(this.$t('deviceMg.message.abnormal'))
          this.controlWindowShow = false
          this.addLoading = false
        })
    },
    /*
        *@name:摄像机组编辑
        *@param:{type}
        *@description:
        *@return:
        *@author: tongyu
        *@date: 2019-05-14 11:18
    */
    handleUpdate() {
      this.editLoading = true
      // const currentCameraList = this._.map(this.formNew.cameraBayInfos, 'cameraCode');
      // let addCameraList = []
      // let delCameraList = []
      // if(currentCameraList.join('') !== this.cameraList.join('')) {
      //     let updateCameraList = this.cameraList
      //     addCameraList = this._.difference(updateCameraList,currentCameraList)
      //     delCameraList = this._.difference(currentCameraList,updateCameraList)
      // }
      let delCameraList = _.map(this.formNew.cameraBayInfos, 'cameraCode');
      let addCameraList = this.cameraList
      const params = {
        add_cameraList: addCameraList,
        del_cameraList: delCameraList,
        areaDevGroupCode: this.formNew.areaDevGroupCode,
        bayonetName: this.formNew.bayonetName,
        code: this.formNew.code,
        type: Number(this.formNew.type)
      }
      this.$fetch(api.SERVICE.updatebayonet, params)
        .then(res => {
          if (res.success) {
            this.$message.success(this.$t('deviceMg.message.editSuccess'))
            this.getList(this.page)
            this.editLoading = false
            this.editWindowShow = false
          } else {
            this.editLoading = false
            this.$message.error(res.msgContent)
          }
        })
        .catch(() => {
          this.editLoading = false
          this.editWindowShow = false
        })
    },
    handleSelectionChange(items) {
      this.checkedDivs = items.map(item => {
        return item.code
      })
    }
  }
}
</script>
<style scoped>
    .camera-delete-icon {
        cursor: pointer;
        float: right;
        line-height: 28px;
    }

    .camera-delete-icon:hover {
        color: #0086ff;
    }

    .camera-list {
        width: 80%;
        position: relative;
        top: -28px;
        border: 1px solid #596f94;
        height: 100px;
        padding-left: 10px;
    }

    .camera-list-title {
        position: relative;
        top: -28px;
    }

    .open-cameta-button {
        color: #0086ff;
        font-weight: bolder;
        cursor: pointer;
        position: relative;
        top: -28px;
        left: 63%;
    }
</style>
<style lang="scss">
.devicemg_warps{
    .el-table__fixed-right-patch {display: none;}
}
</style>
